// Minimal subscription shape shared by the renderer's typed `Subscription`
// (@/shared/api) and the main process's electron-store copy of it.
export interface EntitlementSubscription {
  is_active?: boolean
  entitlements?: { sku?: string | null }
}

// Single source of truth for "does this subscription grant Full Access".
// Consumed by BOTH the renderer (authStore.hasFullAccess getter) and the main
// process (desktop/main/utils/entitlement.ts, gating the global quick-search
// shortcut), so a change to who counts as Full Access can't silently drift
// between the two enforcement points. The 'FULL_ACCESS' literal mirrors
// SkuEnum.FullAccess in @/shared/api — kept inline so the main-process bundle
// doesn't need to import the generated SDK.
export function grantsFullAccess(
  subscription: EntitlementSubscription | null | undefined
): boolean {
  return subscription?.is_active === true && subscription?.entitlements?.sku === 'FULL_ACCESS'
}
